import { useContext } from "react";

import {
  TenantContext,
  type TenantContextValue,
} from "@/components/tenant/TenantContextProvider";

export function useTenant(): TenantContextValue {
  return useContext(TenantContext);
}
